import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment } from 'react';
import * as ScreenSizes from 'ecosystem-marketplace-core/constants/layout/ScreenSizes';
import FormattedMessage from 'I18n/components/FormattedMessage'; // @ts-expect-error module is untyped

import MobileFilterBar from 'ecosystem-marketplace-core/js/components/mobile/MobileFilterBar';
import Small from 'UIComponents/elements/Small';
import UIButton from 'UIComponents/button/UIButton';
import UIFlex from 'UIComponents/layout/UIFlex';
import { useIsMaxScreenSize } from 'ecosystem-marketplace-core/hooks/useScreenSize';
import FilterTag, { MobileFilterTag } from './FilterTag';

function ClearFiltersButton({
  onClear
}) {
  return /*#__PURE__*/_jsx(UIButton, {
    className: "m-left-3 flex-shrink-0",
    onClick: () => onClear(),
    responsive: false,
    use: "link",
    children: /*#__PURE__*/_jsx(Small, {
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "marketplace-assets-ui.themes.results.clearFilters"
      })
    })
  });
}

function DesktopResultsFilters({
  filters,
  onClearAllFilters,
  onClearFilter
}) {
  if (!filters.length) return null;
  return /*#__PURE__*/_jsxs(UIFlex, {
    align: "center",
    wrap: "wrap",
    children: [filters.map(({
      name,
      value
    }) => /*#__PURE__*/_jsx(FilterTag, {
      onClear: onClearFilter,
      name: name,
      value: value
    }, `filter-tag-${name}-${value}`)), /*#__PURE__*/_jsx(ClearFiltersButton, {
      onClear: () => onClearAllFilters()
    })]
  });
}

function MobileResultsFilters({
  filters,
  onClearAllFilters,
  onClearFilter,
  onOpenFilterPanel,
  resultsFiltersRef
}) {
  return /*#__PURE__*/_jsx(MobileFilterBar, {
    startSlot: /*#__PURE__*/_jsx(Fragment, {
      children: /*#__PURE__*/_jsx(UIButton, {
        buttonRef: resultsFiltersRef,
        onClick: () => onOpenFilterPanel(),
        size: "sm",
        style: {
          width: 'initial'
        },
        use: "tertiary-light",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "marketplace-assets-ui.themes.results.filter"
        })
      })
    }),
    middleSlot: /*#__PURE__*/_jsxs(Fragment, {
      children: [filters.map(({
        name,
        value
      }) => /*#__PURE__*/_jsx(MobileFilterTag, {
        onClear: onClearFilter,
        name: name,
        value: value
      }, `filter-tag-${name}-${value}`)), filters.length > 0 && /*#__PURE__*/_jsx(ClearFiltersButton, {
        onClear: () => onClearAllFilters()
      })]
    })
  });
}

function ResultsFilters(props) {
  const isMobile = useIsMaxScreenSize(ScreenSizes.LG);

  if (isMobile) {
    return /*#__PURE__*/_jsx(MobileResultsFilters, Object.assign({}, props));
  }

  return /*#__PURE__*/_jsx(DesktopResultsFilters, Object.assign({}, props));
}

export default ResultsFilters;